import React, { memo } from 'react'
import { BodyText, HeadingText, Link } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import {
  DATA_PRIVACY_SETTINGS,
  MERCHANT_DATA_PRIVACY_SETTINGS,
  PRIVACY_FORM,
} from '../../constants/constants'
import PrivacyOption from './privacy-option'
import serverData from '../../utils/server-data'
const { isMerchantUser } = serverData

const DataChoices = memo((props) => {
  let displayInnerContent
  const privacyhub = 'privacyhub.'
  if (props.keys.datachoices) {
    displayInnerContent = props.keys.datachoices.split(',').map((key) =>
      privacyhub + key + '.content' ===
      'privacyhub.dataChoices.access.content' ? (
        <PrivacyOption
          key={key}
          heading={<Message id={privacyhub + key + '.heading'} />}
          content={
            <Message
              id={privacyhub + key + '.content'}
              link={(innerMessage) => (
                <Link
                  theme="v2"
                  name="privacyhub_dataChoices_content"
                  id="contactUsLink"
                  className="privacy_settings"
                  href={PRIVACY_FORM}
                  target="_blank"
                >
                  {innerMessage}
                </Link>
              )}
            />
          }
        />
      ) : (
        <PrivacyOption
          key={key}
          heading={<Message id={privacyhub + key + '.heading'} />}
          content={<Message id={privacyhub + key + '.content'} />}
        />
      ),
    )
  }
  return (
    <div className="privacyHub-model">
      <HeadingText
        id="dataRightsHeader"
        className="privacyHub-model-heading"
        size="lg"
      >
        <Message id="privacyhub.datarights.header" />
      </HeadingText>

      <HeadingText className="privacyHub-model-subheader" size="sm">
        <Message id="privacyhub.datarights.subheader" />
      </HeadingText>
      <BodyText size="lg">
        <Message
          id="privacyhub.datarights.component.desc"
          link={(innerMessage) => (
            <Link
              theme="v2"
              name="privacy_settings"
              id="privacySettingsLink"
              href={
                isMerchantUser
                  ? MERCHANT_DATA_PRIVACY_SETTINGS
                  : DATA_PRIVACY_SETTINGS
              }
            >
              {innerMessage}
            </Link>
          )}
        />
      </BodyText>
      <BodyText size="lg" className="privacyHub-model-content">
        <Message id="privacyhub.datarights.component.desc1" />
      </BodyText>

      {displayInnerContent}

      <HeadingText className="privacyHub-model-subheader" size="sm">
        <Message id="privacyhub.datarights.subheader2" />
      </HeadingText>
      <BodyText size="lg" className="privacyHub-model-content">
        <Message
          id="privacyhub.datarights.component.desc2"
          link={(innerMessage) => (
            <Link
              theme="v2"
              name="privacy_settings"
              id="privacyHelpLink"
              href={PRIVACY_FORM}
              target="_blank"
            >
              {innerMessage}
            </Link>
          )}
        />
      </BodyText>
    </div>
  )
})

DataChoices.displayName = 'PrivacyDataRights'

export default DataChoices
